<template>
    <footer style="background-color: #3a4767 !important;padding-top: 10px;" class="footeraksi">
        <div class="row">
            <div class="col-sm-12 text-center wow fadeInUp">
                <a class="btn btn-app" :class="[((route.name == 'Aksi') ? 'bg-warning' : 'bg-info')]"
                    @click="dashboard()">
                    <i class="fas fa-home text-white"></i> <span class="text-white">Dashboard</span>
                </a>
                <a class="btn btn-app" :class="[((route.name == 'Google') ? 'bg-warning' : 'bg-info')]"
                    @click="google()">
                    <i class="fas fa-map-marked-alt text-white"></i> <span class="text-white">Lokasiku</span>
                </a>
                <a class="btn btn-app" :class="[((route.name == 'Izin') ? 'bg-warning' : 'bg-info')]" @click="izin()">
                    <i class="far fa-calendar text-white"></i> <span class="text-white">Izin / Cuti</span>
                </a>
                <a class="btn btn-app" :class="[((route.name == 'DL') ? 'bg-warning' : 'bg-info')]" @click="dl()">
                    <i class="fas fa-train text-white"></i> <span class="text-white">Perjalanan Dinas</span>
                </a>
                <a class="btn btn-app" :class="[((route.name == 'Statistik') ? 'bg-warning' : 'bg-info')]" @click="statistik()">
                    <i class="fas fa-chart-bar text-white"></i> <span class="text-white">Statistik</span>
                </a>
                <a class="btn btn-app" :class="[((route.name == 'ProfilAksi') ? 'bg-warning' : 'bg-info')]" @click="profil()">
                    <i class="fas fa-user-alt text-white"></i> <span class="text-white">Profil</span>
                </a>
                <a class="btn btn-app bg-info" @click="keluar()">
                    <i class="fas fa-sign-out-alt text-white"></i> <span class="text-white">Keluar</span>
                </a>
            </div>
        </div>
    </footer>
</template>

<script>
import swal from 'sweetalert2';
import { useRoute } from 'vue-router';
import { watch } from 'vue';
export default {
    setup() {
        const route = useRoute()
        watch(() => route.name, () => {
        });

        return { route };
    },
    data() {
        return {
            tahun: new Date().getFullYear(),
            iduser: JSON.parse(localStorage.getItem("isistemaksi")),
        }
    },
    methods: {
        getOtentifikasi() {
            if (this.iduser == null || this.iduser == undefined || this.iduser == '') {
                localStorage.removeItem('tokensistemaksi');
                localStorage.removeItem('isistemaksi');
                localStorage.removeItem('lsistemaksi');
                localStorage.removeItem('project_idaksi');
                localStorage.removeItem('namasistemaksi');
                localStorage.removeItem('jabatansistemaksi');
                localStorage.removeItem('ikonsistemaksi');
                localStorage.removeItem('jenis_piusistemaksi');
                localStorage.removeItem('tsistem');
                window.location.replace("/AksiLogin");
            }
        },
        dashboard() {
            window.location.replace("/Aksi");
        },
        google() {
            window.location.replace("/Google");
        },
        izin() {
            window.location.replace("/Izin");
        },
        dl() {
            window.location.replace("/DL");
        },
        profil() {
            window.location.replace("/ProfilAksi");
        },
        statistik() {
            window.location.replace("/Statistik");
        },
        keluar() {
            swal.fire({
                title: "Konfirmasi",
                text: "Yakin Hendak Keluar Aplikasi?",
                icon: "warning",
                showCancelButton: true,
                cancelButtonText: "Batal",
                confirmButtonColor: "#3a4767",
                cancelButtonColor: "#ffaa05",
                confirmButtonText: "Keluar"
            }).then((result) => {
                if (result.isConfirmed) {
                    this.ClearlocalStorageAksi();
                }
            });

            return false;
        },
    },
    mounted() {
        this.getOtentifikasi();
        this.halamanloading = false;
    }
}
</script>

<style></style>